export default __webpack_public_path__ + "static/media/quiz_bg.4056f56b.png";